export enum ViewType {
  FULL = 'full',
  BREAKDOWN = 'breakdown',
}
